// extracted by mini-css-extract-plugin
module.exports = {"ModalBox":"DeleteFluxModal_ModalBox__GCmZI","ButtonGroup":"DeleteFluxModal_ButtonGroup__3uL6F"};